/**
 * Textos (`ca`) de pantalla d'Existències del BackOffice per Lot + Lloc (OBR-143, OBR-146, OBR-14): ajust, «Lot nou d'ajust»,
 * bloqueig, estats i «A regularitzar». Namespaces `backoffice.stockLine` i `backoffice.stockRegularize`. Tall propi: no es toca
 * `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const stockLineCa = {
  'backoffice.stockLine': {
    // Estat del lot en un lloc (OBR-14)
    filterBlocked: 'Bloquejat',
    blockedSince: 'Bloquejat el {{date}}',
    blockedReason: 'Motiu: {{reason}}',
    blockedNoReason: 'Sense motiu escrit',
    blockedHint:
      'Lots bloquejats a mà, excepcions de recepció pendents de decisió i devolucions pendents de retornar: no compta com a disponible per a producció.',

    // Accions per línia (lot + lloc)
    actionAdjust: 'Ajusta',
    actionBlock: 'Bloqueja',
    actionUnblock: 'Desbloqueja',
    actionNewLot: 'Lot nou d’ajust',

    // Ajust per lot + lloc (OBR-143)
    adjustBody:
      'L’ajust es fa sobre aquest lot en aquest lloc. Els moviments no s’editen mai: queda un moviment nou amb el motiu escrit.',
    adjustFieldLot: 'Lot',
    adjustFieldPlace: 'Lloc',
    adjustFieldBalance: 'Existències ara',
    adjustNoLot: 'Sense lot',
    adjustAfter: 'Quedaran {{quantity}} {{unit}}.',
    adjustNegative:
      'No es pot deixar el saldo per sota de 0: en aquest lot i lloc només n’hi ha {{quantity}} {{unit}}.',
    adjustNoLotHint:
      'Aquestes existències no tenen lot: només se’n poden treure. Per donar-ne d’alta, fes servir «Lot nou d’ajust».',
    adjustLotRequired:
      'Per afegir existències cal un lot. Fes servir «Lot nou d’ajust».',
    adjustExpiry: 'Caducitat del lot',
    adjustExpiryHint: 'Aquest lot no en té i l’article la demana: cal indicar-la per afegir-hi existències.',
    adjustExpiryInvalid: 'Indica una data de caducitat.',

    // Lot nou d'ajust (OBR-143)
    newLotTitle: 'Lot nou d’ajust',
    newLotBody:
      'Dona d’alta existències que no tenen lot: es crea un lot intern nou i queda un moviment d’ajust amb el motiu escrit.',
    newLotSupplierCode: 'Codi de lot del proveïdor',
    newLotSupplierCodeHint: 'Opcional: el que porta l’envàs.',
    newLotExpiry: 'Caducitat',
    newLotExpiryRequired: 'Obligatòria per a aquest article.',
    newLotExpiryOptional: 'Opcional per a aquest article.',
    newLotExpiryInvalid: 'Indica la data de caducitat.',
    newLotPlace: 'Lloc',
    newLotPlacePlaceholder: 'Tria on són',
    newLotQuantity: 'Quantitat',
    newLotQuantityHint: 'Més gran que zero, en {{unit}}.',
    newLotQuantityInvalid: 'Ha de ser més gran que zero.',
    newLotQuantityTooMuch: 'No pot passar de les {{quantity}} {{unit}} que hi ha sense lot.',
    newLotReason: 'Motiu',
    newLotConfirm: 'Crea el lot',
    newLotCreating: 'Creant…',
    newLotProduction:
      'Aquest article es produeix: el seu lot el genera l’ordre de treball en tancar-la i no es pot crear a mà. Si les existències no quadren, ajusta un lot que ja existeixi.',
    newLotNoStock:
      'Aquest article no té control d’existències: no hi ha existències per donar d’alta.',
    noDefaultPlace: 'Sense lloc per defecte',
    noDefaultPlaceHint:
      'Aquest article no té lloc per defecte. Tria’n un o les existències quedaran «Sense lloc» i caldrà regularitzar-les.',
    defaultPlaceHint: 'Lloc per defecte de l’article.',
    defaultPlaceUnavailableHint:
      'El lloc per defecte de l’article ja no accepta existències. Tria’n un altre o quedaran «Sense lloc».',
    // Avís en triar un destí on el lot ja és bloquejat (no bloqueja el moviment).
    destinationBlocked_one: 'El destí té aquest lot bloquejat: el que hi moguis hi quedarà bloquejat.',
    destinationBlocked_other:
      'El destí té {{count}} d’aquests lots bloquejats: el que hi moguis hi quedarà bloquejat.',

    // Bloqueig i desbloqueig (OBR-14)
    blockTitle: 'Bloqueja el lot',
    unblockTitle: 'Desbloqueja el lot',
    blockBody:
      'Un lot bloquejat no es pot consumir ni expedir i l’app de planta no el proposa. Les existències hi continuen físicament i el pots desbloquejar quan vulguis.',
    unblockBody: 'El lot tornarà a estar disponible per consumir i expedir.',
    stateReason: 'Motiu',
    stateReasonPlaceholder: 'Opcional: per què es bloqueja o es desbloqueja',
    blockConfirm: 'Bloqueja',
    unblockConfirm: 'Desbloqueja',
    stateWorking: 'Desant…',

    // Errors del servidor, en llenguatge d’obrador
    errNegative:
      'No es pot deixar el saldo per sota de 0. Les existències d’aquest lot han canviat: torna a obrir-lo per veure el que hi queda.',
    errLotRequired: 'Per afegir existències cal un lot. Fes servir «Lot nou d’ajust».',
    errExpiryRequired: 'Aquest article demana caducitat: indica-la.',
    errForbidden: 'No tens permís per ajustar existències.',
    errBadPlace: 'Aquest lloc ja no admet existències. Tria’n un altre.',
    errWorkOrder:
      'Aquest article es produeix: el seu lot el crea una ordre de treball en tancar-la i no es pot donar d’alta a mà.',
    errStateForbidden:
      'Només administració, responsable de producció i qualitat poden bloquejar o desbloquejar.',
    errGeneric: 'No s’ha pogut desar. Torna-ho a provar.',
  },

  'backoffice.stockRegularize': {
    tab: 'A regularitzar',
    tabsLabel: 'Vista d’existències',
    tabStock: 'Existències',
    title: 'Existències per regularitzar',
    subtitle:
      'Existències que no es poden traçar o que no quadren: sense lot, en negatiu, sense caducitat o sense lloc.',
    filterKind: 'Problema',
    kindAll: 'Tots',
    kind_no_lot: 'Sense lot',
    kind_negative: 'Saldo negatiu',
    kind_no_expiry: 'Sense caducitat',
    kind_no_place: 'Sense lloc',
    hint_no_lot: 'No pertanyen a cap lot: no són traçables ni es poden expedir.',
    hint_negative: 'S’ha gastat més del que constava. Ajusta el saldo amb el motiu escrit.',
    hint_no_expiry: 'El lot no té data de caducitat i l’article la demana.',
    hint_no_place: 'No tenen lloc: no se sap on són. Posa-les on toca.',
    colArticle: 'Article',
    colLot: 'Lot',
    colPlace: 'Lloc',
    colQuantity: 'Quantitat',
    colProblem: 'Problema',
    empty: 'Tot en ordre: no hi ha existències per regularitzar.',
    emptyFiltered: 'Cap línia coincideix amb el filtre.',
    loadError: 'No s’ha pogut carregar la llista.',
    actionAssignLot: 'Assigna un lot',
    actionAdjustZero: 'Ajusta a zero',
    actionSetExpiry: 'Posa la caducitat',
    actionPlace: 'Posa-les a un lloc',
    noActionHint: 'Aquesta línia es regularitza des de l’app de planta o amb un lot d’ajust.',
    assignTitle: 'Assigna un lot nou',
    assignBody:
      'Es crea un lot intern amb la caducitat que indiquis i se li passen aquestes existències; la línia sense lot queda a zero.',
    assignPartial:
      'S’ha creat el lot, però no s’ha pogut deixar a zero la línia sense lot. Ajusta-la a zero des d’aquesta llista.',
    zeroTitle: 'Ajusta a zero',
    zeroNote: 'Regularització: línia ajustada a zero.',
    assignNote: 'Regularització: existències sense lot passades a un lot nou.',
    expiryTitle: 'Posa la caducitat del lot',
    expiryBody:
      'Només canvia la data de caducitat del lot; les existències i els moviments no es toquen.',
    expiryLabel: 'Caducitat',
    expiryConfirm: 'Desa la caducitat',
    expiryInvalid: 'Indica la data de caducitat.',
    expiryForbidden: 'No tens permís per canviar la caducitat d’aquest lot.',
    expiryError: 'No s’ha pogut desar la caducitat.',
    expiryWorking: 'Desant…',
  },
} as const;
